import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import {FontLoader} from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

/**
 * Base
 */
// Debug
//const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color('#ffffff')

/**
 * Fog
 */
const fog = new THREE.Fog('#ffffff', 1.2, 5)
scene.fog = fog

/**
 * Material
 */
/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const matcapTexture = textureLoader.load('textures/matcaps/3.png')
/**
 * Gradient
 */
function createCustomGradientMap() {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 1;

    const context = canvas.getContext('2d');
    const gradient = context.createLinearGradient(0, 0, canvas.width, 0);

    gradient.addColorStop(0, 'white');
    gradient.addColorStop(0.2, 'gray');
    gradient.addColorStop(0.5, 'black');
    gradient.addColorStop(0.8, 'gray');
    gradient.addColorStop(1, 'white');

    context.fillStyle = gradient;
    context.fillRect(0, 0, canvas.width, canvas.height);

    const gradientMap = new THREE.CanvasTexture(canvas);
    return gradientMap;
}

/**
 * Object
 */
// Reactor
const reactor1 = new THREE.Mesh(
    new THREE.SphereGeometry(0.03, 16, 16),
    new THREE.MeshMatcapMaterial({color: 0x777777, matcap: matcapTexture})
)
reactor1.position.set(-0.0, 0.35, 0.0)
//scene.add(reactor1)

let reactor2;
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        const textGeometry = new TextGeometry(
            'M1: 37m2',
            {
                font: font,
                size: 0.04,
                height: 0.005,
                curveSegments: 5,
                bevelEnabled: true,
                bevelThickness: 0.00,
                bevelSize: 0.000,
                bevelOffset: 0,
                bevelSegments: 0
            }
        )
        textGeometry.center()

        textGeometry.computeBoundingBox()
        textGeometry.translate(
            - (textGeometry.boundingBox.max.x -0.02) * 0.5,
            - (textGeometry.boundingBox.max.y -0.02) * 0.5,
            - (textGeometry.boundingBox.max.z -0.03) * 0.5,
        )
        console.log(textGeometry.boundingBox)

        const material = new THREE.MeshMatcapMaterial({color: 0x777777, matcap: matcapTexture})
        reactor2 = new THREE.Mesh(textGeometry, material)
        reactor2.position.set (-0.2,0.29,-0.29)
        reactor2.rotation.y = Math.PI
        reactor2.rotation.x = Math.PI*0.5
        //scene.add(reactor2)
        }
)

// Imported
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')

const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

let mixer = null

gltfLoader.load('/models/flat_gltf/flat.gltf', (gltf) => {
    gltf.scene.scale.set(0.1, 0.1, 0.1);
    scene.add(gltf.scene);
    console.log(gltf)

    //mixer = new THREE.AnimationMixer(gltf.scene)
    //const action = mixer.clipAction(gltf.animations[0])
    //action.play()

    gltf.scene.traverse((child) => {
        if (child.isMesh) {
            child.castShadow = false;
            child.receiveShadow = false;

            const edgesGeometry = new THREE.EdgesGeometry(child.geometry);
            const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x696969, linewidth: 1 });
            const edges = new THREE.LineSegments(edgesGeometry, edgesMaterial);
            child.add(edges);

            child.material = new THREE.MeshToonMaterial({
                color: 0xEFEFEF,
                gradientMap: createCustomGradientMap()
            });
        }
    });

});

/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

// Directional light
const light = new THREE.DirectionalLight('#F1F1F1', 5)
light.position.set(-1, 5, - 2)
scene.add(light)
light.shadow.mapSize.width = 64
light.shadow.mapSize.height = 64
light.shadow.camera.far = 10
light.castShadow = false

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Cursor
 */
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) => {
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = -(event.clientY / sizes.height * 2 - 1)
})

window.addEventListener('click', () => {
    if (currentIntersect) {
        console.log('kliknięto na sferę');
    }
    console.log('kliknięto');
})

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0.5, 0.8, 0.3)
scene.add(camera)

/**
 * Controls
 */
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = false
renderer.shadowMap.type = THREE.PCFShadowMap

/**
 * Animate
 */
const clock = new THREE.Clock()

let currentIntersect = null;

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    raycaster.setFromCamera(mouse, camera)

    const objectsToTest = [reactor1]
    const intersects = raycaster.intersectObjects(objectsToTest)

    for (const object of objectsToTest) {
        object.material.color.set('#777777')
        object.scale.set(1, 1, 1)
    }

    for (const intersect of intersects) {
        intersect.object.material.color.set('#ff0000')
        intersect.object.scale.set(1.5, 1.5, 1.5)
    }

    if (intersects.length) {
        if (!currentIntersect) {
            console.log('kursor wszedł na obiekt');
        }
        currentIntersect = intersects[0]
    } else {
        if (currentIntersect) {
            console.log('kursor opuścił obiekt');
        }
        currentIntersect = null
    }

    controls.update()
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}

tick()
